<template>
  <div v-if="bits">
    <b-row>
      <b-col cols="2" />
      <b-col cols="5"><h3>Picture</h3></b-col>
      <b-col cols="5"><h3>Video</h3></b-col>
    </b-row>
    <b-row>
      <b-col cols="2">
        <h3>Alarm</h3>
      </b-col>
      <b-col v-for="(c, ci) in 10" cols="1">
        <base-input :label="cameras[ci]">
          <b-form-checkbox class="mb-3" :key="ci" v-model="bits[ci]" @input="onBitChanged(ci)" />
        </base-input>
      </b-col>
    </b-row>
    <div style="display: none;">
      Calculate camera mask => {{ cameraMask }}
    </div>
  </div>
</template>

<script>
export default {
  name: "calculate-camera-alarm-mask",
  props: {
    cameraMask: {
      type: Object,
      required: true,
      description: "Camera mask"
    }
  },
  mounted() {
    this.setBits()
  },
  watch: {
    cameraMask: {
      handler(value) {
        this.setBits()
      },
      deep: true
    },
  },
  data: _ => ({
    cameras: [ 'Front', 'Rear', 'Left', 'Right', 'Driver', 'Front', 'Rear', 'Left', 'Right', 'Driver' ],
    cameraBits: [ 1, 2, 4, 8, 16, 32, 64, 128, 256, 512 ],
    bits: undefined
  }),
  methods: {
    setBits() {
      if (!this.bits) {
        this.bits = []
      }

      for (let c = 0 ; c < 10 ; c++) {
        this.bits[c] = this.getEnabled(c)
      }
    },
    getEnabled(camera) {
      let mask = this.cameraMask.value

      return (mask & this.cameraBits[camera]) === this.cameraBits[camera]
    },
    onBitChanged(camera) {
      let strMask = ''

      for (let i = 9 ; i >= 0 ; i--) {
        strMask += this.bits[i]? '1' : '0'
      }

      this.cameraMask.value = parseInt(strMask, 2).toString()
    },
  }
}
</script>

<style scoped>

</style>
